'use strict';
define([], function () {
    function Controller(
        AuthService,
        $scope,
        $stateParams,
        $state,
        $mdToast,
        $translate,
        ProjectsService,
        $element,
        LanguageService,
        CountriesService,
        TimezoneService,
        FavIconService,
        $debounce,
        stAlertLimitService,
        UserService,
        KeywordTrackerService,
        TrackEventService,
        $rootScope,
        CRMService,
        SearchConsoleService,
        $window,
        $interval,
        $q,
    ) {
        var stepKeys = {
            'create-project': 1,
            'search-console': 2,
            'crawl-settings': 3,
            'schedule-audits': 4,
            'add-keywords': 5,
            'set-locations': 6
        };
        var initialStep = stepKeys[$stateParams.step] ? stepKeys[$stateParams.step] : 1;
        var draftStoragePrefix = 'projectWizardDraftV1';
        var createdProjectStoragePrefix = 'projectWizardCreatedProjectV1';
        var draftMaxAge = 7 * 24 * 60 * 60 * 1000;
        var createdProjectMaxAge = 60 * 60 * 1000;
        var storageSuffix = currentWorkspaceStorageSuffix();
        var wizardDraftKey = draftStoragePrefix + storageSuffix;
        var createdProjectKey = createdProjectStoragePrefix + storageSuffix;
        if ($stateParams.fresh === '1' || $stateParams.fresh === true) {
            clearWizardDraft();
        }
        var wizardDraft = readWizardDraft();
        var requestedDraftUrl = $stateParams.url ? cleanUrl($stateParams.url) : '';
        var savedDraftUrl = wizardDraft && wizardDraft.project && wizardDraft.project.url ?
            cleanUrl(wizardDraft.project.url) : '';
        var restoreDraft = wizardDraft && (!requestedDraftUrl ||
            (savedDraftUrl && savedDraftUrl === requestedDraftUrl)) ? wizardDraft : null;
        var createdProject = readCreatedProject();
        var vm = $scope;
        var gscPoll = null;
        var gscAuthWindow = null;

        if (createdProject) {
            $state.go('app.project.detail.overview', {
                projectId: createdProject.projectId
            }).then(function () {
                clearCreatedProjectMarker();
            }).catch(function (err) {
                console.log('Unable to resume the created project overview', err);
            });
            return;
        }

        vm.isFirstProject = $stateParams.firstproject;
        vm.sourceMode = $stateParams.url ? 'manual' :
            ((restoreDraft && restoreDraft.sourceMode) || localStorage.getItem('projectWizardSource'));
        vm.gsc = {
            loading: false,
            error: null,
            draftId: restoreDraft && restoreDraft.gsc && restoreDraft.gsc.draftId || null,
            properties: restoreDraft && restoreDraft.gsc && Array.isArray(restoreDraft.gsc.properties) ?
                restoreDraft.gsc.properties.slice() : [],
            selectedProperty: restoreDraft && restoreDraft.gsc && restoreDraft.gsc.selectedProperty || null,
            requested: false
        };
        vm.domainTypes = [
            {id: 'domain_with_subdomains', label: 'project.wizard.analyze.all', detail: 'project.wizard.domain.including.subdomains'},
            {id: 'domain_without_subdomains', label: 'project.wizard.domain', detail: 'project.wizard.only.specified.domain'},
            {id: 'prefix', label: 'project.wizard.path', detail: 'project.wizard.path.including.subfolders'},
            {id: 'exact_url', label: 'project.wizard.exact.url', detail: 'project.wizard.only.specified.url'}
        ];
        var projectNameWasChanged = false;
        var draftReady = false;
        var reviewKeywordsPageSize = 100;

        vm.accountLanguages = $translate.getAvailableLanguageKeys();
        vm.selectedAccountLanguage = LanguageService.getCodeAndCountrySaveOnStorage();
        vm.switchAccountLanguage = switchAccountLanguage;

        function switchAccountLanguage(language) {
            vm.selectedAccountLanguage = language;
            if (vm.step === 1) {
                suggestDefaultLocationCountry();
            }
            try {
                $rootScope.setLang(language)
                    .catch(function (error) {
                        console.log(error);
                    });
            } catch (error) {
                console.log(error);
            }
            if (AuthService.isAuthenticated()) {
                UserService.updateProfile({locale: language})
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }

        // Keywords
        vm.keywords = restoreDraft && Array.isArray(restoreDraft.keywords) ? restoreDraft.keywords.slice() : [];
        vm.keywordDiscoveryState = {};
        vm.keywordsLimit = 15;
        vm.keywordsAlreadyAddedCounter = 0;
        vm.keywordsCount = vm.keywords.length;
        vm.reviewKeywordsPage = 0;
        vm.reviewKeywordsPageRows = [];
        vm.reviewKeywordsPages = 1;
        vm.changeReviewKeywordsPage = changeReviewKeywordsPage;
        /* Never show a negative "available": 0 means the allowance is used up. */
        vm.keywordsAvailable = function () {
            var left = vm.keywordsLimit - vm.keywordsAlreadyAddedCounter;
            return left > 0 ? left : 0;
        };

        // Locations
        var defaultLocations = [{
            searchEngineId: 1,
            countryCode: LanguageService.getCountryCodeSaveOnStorage() || 'US',
            deviceId: 1
        }];
        var defaultLocationCountrySuggested = !!restoreDraft;
        vm.locations = restoreDraft && Array.isArray(restoreDraft.locations) && restoreDraft.locations.length ?
            restoreDraft.locations.slice() : defaultLocations;
        vm.locationsCount = vm.locations.length || 1;
        vm.removeLocation = removeLocation;

        // Competitors
        vm.competitors = [];
        vm.suggestedCompetitors = [];

        var defaultSchedule = {
            crawlerNow: true,
            runScheduled: true,
            respectRobots: true,
            maxDepth: '∞',
            resourcesLimit: 100,
            userAgent: 'STO',
            speed: 5,
            scheduleFrequency: 'monthly',
            scheduleStartDay: 1,
            scheduleStartHour: 1,
            scheduleTimezoneOffset: 0,
        };
        vm.schedule = angular.extend({}, defaultSchedule, restoreDraft && restoreDraft.schedule || {});
        vm.scheduleSpeedLabel = scheduleSpeedLabel;
        var allWizardResourceOptions = [10, 25, 50, 100, 150, 200, 250, 500, 1000, 1500, 2000, 3000, 4000, 5000, 10000, 20000, 50000, 100000];
        vm.wizardResourceOptions = [];
        vm.resourceLimits = {
            loading: false,
            ready: false,
            error: false,
            max: null,
            pickerOpen: false,
            availableOptions: [],
            lockedOptions: []
        };
        vm.wizardUserAgents = [
            {value: 'STO', label: 'SEO Tester Bot'},
            {value: 'GOOGLEBOT', label: 'GoogleBot'},
            {value: 'GOOGLEBOT_MOBILE', label: 'GoogleBot Mobile'},
            {value: 'GOOGLEBOT_SMARTPHONE', label: 'GoogleBot Smartphone'},
            {value: 'BING', label: 'BingBot'},
            {value: 'CHROME', label: 'Chrome'},
            {value: 'OPERA', label: 'Opera'},
            {value: 'FIREFOX', label: 'Firefox'},
            {value: 'EDGE', label: 'Edge'}
        ];
        vm.wizardSpeedOptions = [
            {value: 1, label: 'seospider.ultra.slow', rate: '0.1'},
            {value: 2, label: 'seospider.very.slow', rate: '0.2'},
            {value: 3, label: 'seospider.slow', rate: '1'},
            {value: 4, label: 'seospider.moderate', rate: '5'},
            {value: 5, label: 'seospider.normal', rate: '10'},
            {value: 6, label: 'seospider.fast', rate: '15'},
            {value: 7, label: 'seospider.very.fast', rate: '25'},
            {value: 8, label: 'seospider.ultra.fast', rate: '50'}
        ];
        vm.wizardMonthDays = Array.apply(null, {length: 31}).map(function (_, index) {
            return index + 1;
        });
        vm.wizardWeekDays = [
            {value: 0, label: 'monday'},
            {value: 1, label: 'tuesday'},
            {value: 2, label: 'wednesday'},
            {value: 3, label: 'thursday'},
            {value: 4, label: 'friday'},
            {value: 5, label: 'saturday'},
            {value: 6, label: 'sunday'}
        ];
        vm.wizardHourOptions = Array.apply(null, {length: 24}).map(function (_, index) {
            return index;
        });
        vm.wizardTimezones = TimezoneService.getAllTimezoneOptions();
        vm.wizardHourLabel = function (hour) {
            return ('0' + hour).slice(-2) + ':00';
        };
        vm.wizardTimezoneOptionLabel = function (timezone) {
            var offset = Number(timezone && timezone.offset) || 0;
            var absoluteOffset = Math.abs(offset);
            var hours = Math.floor(absoluteOffset);
            var minutes = Math.round((absoluteOffset - hours) * 60);
            var offsetLabel = 'GMT' + (offset < 0 ? '-' : '+') + hours +
                (minutes ? ':' + ('0' + minutes).slice(-2) : '');
            var description = String(timezone && timezone.text || '')
                .replace(/^\(GMT[^)]*\)\s*/, '');
            return offsetLabel + (description ? ' · ' + description : '');
        };

        function scheduleSpeedLabel() {
            var rates = {
                1: '0.1',
                2: '0.2',
                3: '1',
                4: '5',
                5: '10',
                6: '15',
                7: '25',
                8: '50'
            };
            var value = rates[vm.schedule.speed] || vm.schedule.speed;
            return $translate.instant('workspace.pagesPerSecond', {value: value});
        }

        vm.steps = setStepsWizard();
        vm.showCustomToast = showCustomToast;
        vm.step = initialStep;

        vm.loading = {
            exceeded: false,
            post: false,
            creatingProject: false,
            suggestedKeywords: false
        };
        vm.limits = {
            loading: false,
            loaded: false,
            error: false,
            ready: false
        };

        var projectFromLocalStorate = readStorageJson('project') || {};
        var storedProject = restoreDraft && restoreDraft.project || projectFromLocalStorate || {};
        if (!$stateParams.url) {
            vm.project = {
                name: storedProject.name || '',
                url: storedProject.url || '',
                protocol: storedProject.protocol || 'both',
                domainType: storedProject.domainType || 'domain_with_subdomains',
            };
        } else {
            vm.project = {
                name: getNameFromURL($stateParams.url),
                url: cleanUrl($stateParams.url),
                protocol: 'both',
                domainType: 'domain_with_subdomains',
            };
        }
        vm.projectNameDuplicateError = false;

        if (vm.step === 1 && !$stateParams.url && !restoreDraft) {
            vm.sourceMode = null;
            vm.project.name = '';
            vm.project.url = '';
            localStorage.removeItem('projectWizardSource');
        } else if (!restoreDraft && $stateParams.url) {
            suggestDefaultLocationCountry();
        }

        /* Deep links and browser history cannot resume an advanced wizard step
           without its draft: otherwise the user can bypass name validation and
           submit a second project after the first one was already created. */
        if (vm.step > 1 && !restoreDraft) {
            vm.step = 1;
            $scope.$evalAsync(function () {
                updateUrlParams(1);
            });
        }

        function getNameFromURL(url) {
            if (!url) {
                return '';
            }
            url = cleanUrl(url);
            if (url.indexOf('.') !== -1 && url.indexOf('.') !== url.length - 1) {
                url = url.split('.')[0];
            }
            return url;
        }

        function cleanUrl(url) {
            return url.replace('https://', '').replace('http://', '').replace('www.', '');
        }

        function suggestDefaultLocationCountry() {
            if (defaultLocationCountrySuggested || !vm.locations || vm.locations.length !== 1) {
                return;
            }
            var domainCountryCode = countryCodeFromDomain(vm.project && vm.project.url);
            var countryCode = domainCountryCode || countryCodeFromSuiteLanguage();
            var location = vm.locations[0];
            if (!countryCode || !location ||
                Number(location.searchEngineId) !== 1 || Number(location.deviceId) !== 1) {
                return;
            }
            location.countryCode = countryCode;
            defaultLocationCountrySuggested = !!domainCountryCode;
        }

        function countryCodeFromDomain(url) {
            var host = String(url || '')
                .replace(/^https?:\/\//i, '')
                .replace(/^www\./i, '')
                .split(/[/?#:]/)[0]
                .toLowerCase();
            var extension = host.split('.').pop();
            var countryAliases = {
                uk: 'GB'
            };
            var candidate = countryAliases[extension] || extension.toUpperCase();
            var country = candidate && CountriesService.getByCode(candidate);
            return country ? country.code : null;
        }

        function countryCodeFromSuiteLanguage() {
            var locale = String(
                vm.selectedAccountLanguage ||
                LanguageService.getCodeAndCountrySaveOnStorage() ||
                ''
            ).replace('_', '-');
            var localeParts = locale.split('-');
            var localeCountry = String(localeParts[1] || '').toUpperCase();
            if (localeCountry && CountriesService.getByCode(localeCountry)) {
                return localeCountry;
            }
            var languageCountries = {
                de: 'DE',
                en: 'US',
                es: 'ES',
                fa: 'IR',
                fr: 'FR',
                it: 'IT',
                ja: 'JP',
                pl: 'PL',
                pt: 'BR',
                zh: 'CN'
            };
            return languageCountries[String(localeParts[0] || '').toLowerCase()] || null;
        }

        function currentWorkspaceStorageSuffix() {
            var user = readStorageJson('ngStorage-currentUser');
            var workspaceId = user && user.workspace && user.workspace.id;
            return ':workspace:' + (workspaceId || 'anonymous');
        }

        function readStorageJson(key) {
            try {
                return JSON.parse($window.localStorage.getItem(key) || 'null');
            } catch (e) {
                return null;
            }
        }

        function readWizardDraft() {
            var draft = readStorageJson(wizardDraftKey);
            if (!draft || draft.version !== 1 || !draft.updatedAt ||
                Date.now() - draft.updatedAt > draftMaxAge) {
                $window.localStorage.removeItem(wizardDraftKey);
                return null;
            }
            return draft;
        }

        function saveWizardDraft() {
            if (!draftReady || vm.loading.post || vm.loading.creatingProject) {
                return;
            }
            try {
                $window.localStorage.setItem(wizardDraftKey, JSON.stringify({
                    version: 1,
                    updatedAt: Date.now(),
                    step: vm.step,
                    sourceMode: vm.sourceMode,
                    project: angular.copy(vm.project || {}),
                    schedule: angular.copy(vm.schedule || defaultSchedule),
                    keywords: (vm.keywords || []).slice(),
                    locations: angular.copy(vm.locations || defaultLocations),
                    gsc: {
                        draftId: vm.gsc && vm.gsc.draftId || null,
                        properties: vm.gsc && vm.gsc.properties ? angular.copy(vm.gsc.properties) : [],
                        selectedProperty: vm.gsc && vm.gsc.selectedProperty ?
                            angular.copy(vm.gsc.selectedProperty) : null
                    }
                }));
            } catch (e) {
                console.log('Unable to persist project wizard draft', e);
            }
        }

        function clearWizardDraft() {
            $window.localStorage.removeItem(wizardDraftKey);
            $window.localStorage.removeItem('projectWizardSource');
            $window.localStorage.removeItem('projectName');
            $window.localStorage.removeItem('project');
        }

        function readCreatedProject() {
            var marker = readStorageJson(createdProjectKey);
            if (!marker || !marker.projectId || !marker.createdAt ||
                Date.now() - marker.createdAt > createdProjectMaxAge) {
                $window.localStorage.removeItem(createdProjectKey);
                return null;
            }
            return marker;
        }

        function rememberCreatedProject(projectId) {
            try {
                $window.localStorage.setItem(createdProjectKey, JSON.stringify({
                    projectId: projectId,
                    createdAt: Date.now()
                }));
            } catch (e) {
                console.log('Unable to persist created project route', e);
            }
        }

        function clearCreatedProjectMarker() {
            $window.localStorage.removeItem(createdProjectKey);
        }

        function resetProjectNameValidity() {
            vm.projectNameDuplicateError = false;
            if (vm.projectForm && vm.projectForm.name) {
                vm.projectForm.name.$setValidity('server', true);
            }
        }

        function existingProjectFromResponse(response) {
            return response && response.data && response.data.project || null;
        }

        function isSameWizardProject(project) {
            if (!project) {
                return false;
            }
            var existingUrl = String(project.linkUrl || project.url || '')
                .replace(/^https?:\/\//i, '')
                .replace(/^www\./i, '')
                .replace(/\/+$/, '')
                .toLowerCase();
            var wizardUrl = String(vm.project && vm.project.url || '')
                .replace(/^https?:\/\//i, '')
                .replace(/^www\./i, '')
                .replace(/\/+$/, '')
                .toLowerCase();
            return !!existingUrl && existingUrl === wizardUrl;
        }

        function reportDuplicateProjectName(returnToNameStep) {
            vm.projectNameDuplicateError = true;
            if (vm.projectForm && vm.projectForm.name) {
                vm.projectForm.name.$setValidity('server', false);
            }
            showCustomToast('project.wizard.this.name.already.exists', 'icon-x st-red');
            if (returnToNameStep && vm.step !== 1) {
                vm.step = 1;
                updateUrlParams(1);
                $scope.$evalAsync(function () {
                    var input = $element[0].querySelector('#name-input');
                    if (input) {
                        input.focus();
                    }
                });
            }
        }

        function resumeExistingProject(project) {
            if (!project || !project.id) {
                return false;
            }
            rememberCreatedProject(project.id);
            clearWizardDraft();
            vm.loading.post = true;
            vm.loading.creatingProject = true;
            goToProject({projectId: project.id});
            return true;
        }

        vm.onChangeUrl = function () {
            var result;
            var match;
            if (vm.project.url) {
                vm.project.url = vm.project.url.replace('https://', '').replace('http://', '');
            }
            if (projectNameWasChanged || !vm.project.url) {
                return;
            }
            if (match = vm.project.url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\d{0,3}[.])?([^:\/\n\?\=]+)/im)) {
                result = match[1];
                if (match = result.match(/^[^\.]+\.(.+\..+)$/)) {
                    result = match;
                }
            }
            vm.project.name = result && result.indexOf('.') !== -1 ? result.split('.')[0] : '';
            resetProjectNameValidity();
        };

        vm.onChangeName = function () {
            projectNameWasChanged = true;
            resetProjectNameValidity();
        };

        vm.selectSource = function (source) {
            vm.sourceMode = source;
            localStorage.setItem('projectWizardSource', source);
            vm.gsc.error = null;
            if (source === 'search-console' && !vm.gsc.selectedProperty) {
                vm.project.url = '';
                vm.project.name = '';
            }
        };

        vm.connectSearchConsole = connectSearchConsole;
        vm.selectSearchConsoleProperty = selectSearchConsoleProperty;
        vm.skipSearchConsole = skipSearchConsole;
        vm.stepPosition = stepPosition;
        vm.visibleStepCount = visibleStepCount;
        vm.currentStepTitle = currentStepTitle;
        vm.currentStepDescription = currentStepDescription;
        vm.canContinueFromSource = canContinueFromSource;
        vm.projectInitials = projectInitials;
        vm.projectFavicon = projectFavicon;
        vm.countryName = countryName;
        vm.countryFlag = countryFlag;
        vm.locationEngine = locationEngine;
        vm.locationDevice = locationDevice;
        vm.trackingCoverage = trackingCoverage;
        vm.trackingRemaining = trackingRemaining;
        vm.accountKeywordCompletion = accountKeywordCompletion;
        vm.keywordCoverage = keywordCoverage;
        vm.keywordRemaining = keywordRemaining;
        vm.keywordVolume = keywordVolume;
        vm.removeKeyword = removeKeyword;
        vm.clearAllKeywords = clearAllKeywords;
        /* Keep the draft on an object: the editor lives inside an ng-if child
           scope, where a primitive ng-model would shadow the controller value. */
        vm.reviewManual = {
            draft: ''
        };
        vm.manualKeywordsToAdd = manualKeywordsToAdd;
        vm.addManualKeywords = addManualKeywords;
        vm.skipKeywordMonitoring = skipKeywordMonitoring;
        vm.retryLimits = getLimits;

        function connectSearchConsole() {
            if (vm.gsc.loading) {
                return;
            }
            vm.gsc.loading = true;
            vm.gsc.error = null;
            vm.gsc.requested = true;
            $window.localStorage.removeItem('searchConsoleDraftCallback');
            SearchConsoleService.generateDraftAuthUrl()
                .then(function (data) {
                    if (!data || !data.url) {
                        throw new Error('Search Console authorization URL unavailable');
                    }
                    gscAuthWindow = $window.open(data.url, 'sto-search-console-wizard',
                        'location=yes,height=650,width=560,scrollbars=yes,status=yes');
                    if (!gscAuthWindow) {
                        throw new Error('Popup blocked');
                    }
                    startGscPolling();
                })
                .catch(function () {
                    vm.gsc.loading = false;
                    vm.gsc.error = 'project.wizard.gsc.unavailable';
                });
        }

        function startGscPolling() {
            stopGscPolling();
            gscPoll = $interval(function () {
                var raw = $window.localStorage.getItem('searchConsoleDraftCallback');
                if (raw) {
                    var data;
                    try {
                        data = JSON.parse(raw);
                    } catch (e) {
                        data = null;
                    }
                    $window.localStorage.removeItem('searchConsoleDraftCallback');
                    if (data && data.draftId) {
                        stopGscPolling();
                        if (gscAuthWindow && !gscAuthWindow.closed) {
                            gscAuthWindow.close();
                        }
                        vm.gsc.loading = false;
                        vm.gsc.draftId = data.draftId;
                        vm.gsc.properties = (data.sites || []).map(normalizeGscProperty);
                        if (vm.sourceMode === 'manual') {
                            var matching = SearchConsoleService.findMatchingProperty(vm.project.url, data.sites || []);
                            var selected = vm.gsc.properties.filter(function (item) {
                                return item.siteUrl === matching;
                            })[0];
                            if (selected) {
                                selectSearchConsoleProperty(selected);
                            }
                        }
                    }
                    return;
                }
                if (gscAuthWindow && gscAuthWindow.closed) {
                    stopGscPolling();
                    vm.gsc.loading = false;
                }
            }, 700);
        }

        function stopGscPolling() {
            if (gscPoll) {
                $interval.cancel(gscPoll);
                gscPoll = null;
            }
        }

        function normalizeGscProperty(site) {
            var siteUrl = site && site.siteUrl ? site.siteUrl : '';
            var url = siteUrl.replace(/^sc-domain:/i, '').replace(/^https?:\/\//i, '').replace(/\/$/, '');
            return {
                siteUrl: siteUrl,
                url: url,
                name: getNameFromURL(url),
                permissionLevel: site && (site.permissionLevel || site.permission_level) || ''
            };
        }

        function selectSearchConsoleProperty(property) {
            vm.gsc.selectedProperty = property;
            if (vm.sourceMode === 'search-console' && property) {
                vm.project.url = property.url;
                vm.project.name = property.name;
            }
        }

        function skipSearchConsole() {
            vm.gsc.requested = false;
            vm.gsc.draftId = null;
            vm.gsc.selectedProperty = null;
            vm.step = 3;
            updateUrlParams(vm.step);
            prepareKeywordsStep();
        }

        function stepPosition() {
            if (vm.sourceMode === 'search-console') {
                if (vm.step === 1) return 1;
                return vm.step - 1;
            }
            return vm.step;
        }

        function visibleStepCount() {
            return vm.sourceMode === 'search-console' ? 5 : 6;
        }

        function currentStepTitle() {
            return {
                1: 'project.wizard.newFlow.siteTitle',
                2: 'project.wizard.newFlow.gscTitle',
                3: 'project.wizard.newFlow.crawlTitle',
                4: 'project.wizard.newFlow.scanTitle',
                5: 'project.wizard.newFlow.keywordsTitle',
                6: 'project.wizard.newFlow.locationsTitle'
            }[vm.step];
        }

        function currentStepDescription() {
            return {
                1: 'project.wizard.newFlow.siteDescription',
                2: 'project.wizard.newFlow.gscDescription',
                3: 'project.wizard.newFlow.crawlDescription',
                4: 'project.wizard.newFlow.scanDescription',
                5: 'project.wizard.newFlow.keywordsDescription',
                6: 'project.wizard.newFlow.locationsDescription'
            }[vm.step];
        }

        function canContinueFromSource() {
            if (vm.sourceMode === 'search-console') {
                return !!(vm.gsc.draftId && vm.gsc.selectedProperty &&
                    isValidUrl(vm.project.url) && isValidProjectName(vm.project.name));
            }
            return !!(vm.sourceMode === 'manual' &&
                isValidUrl(vm.project.url) && isValidProjectName(vm.project.name));
        }

        function projectInitials() {
            var value = vm.project && vm.project.name ? vm.project.name : '';
            return value.trim().slice(0, 2).toUpperCase() || 'SEO';
        }

        function projectFavicon() {
            if (!vm.project || !vm.project.url || !isValidUrl(vm.project.url)) {
                return '';
            }
            return FavIconService.get(vm.project.url);
        }

        function countryName(countryCode) {
            var country = countryCode && CountriesService.getByCode(String(countryCode));
            return country ? country.name : countryCode;
        }

        function countryFlag(countryCode) {
            return '/assets/img/modules/flags/' + String(countryCode || '').toLowerCase() + '.png';
        }

        function removeLocation(index) {
            if (!vm.locations || vm.locations.length <= 1) {
                showCustomToast('project.wizard.locations.atLeastOne', 'icon-x st-red');
                return;
            }
            vm.locations.splice(index, 1);
        }

        function locationEngine(location) {
            return location && Number(location.searchEngineId) === 4 ? 'Bing' : 'Google';
        }

        function locationDevice(location) {
            return location && Number(location.deviceId) === 2 ? 'Mobile' : 'Desktop';
        }

        function trackingCoverage() {
            var available = Number(vm.keywordsAvailable()) || 0;
            if (!available) {
                return 0;
            }
            return Math.min(100, Math.round(((vm.keywords.length * vm.locationsCount) / available) * 100));
        }

        function trackingRemaining() {
            return Math.max(0, Number(vm.keywordsAvailable()) -
                (vm.keywords.length * vm.locationsCount));
        }

        function accountKeywordCompletion() {
            if (!vm.limits.ready) {
                return 0;
            }
            var limit = Number(vm.keywordsLimit) || 0;
            if (!limit) {
                return 0;
            }
            var used = (Number(vm.keywordsAlreadyAddedCounter) || 0) +
                ((vm.keywords || []).length * Math.max(1, (vm.locations || []).length));
            return Math.min(100, Math.max(0, Math.round((used / limit) * 100)));
        }

        function keywordCoverage() {
            var available = Number(vm.keywordsAvailable()) || 0;
            return available ? Math.min(100, Math.round((vm.keywords.length / available) * 100)) : 0;
        }

        function keywordRemaining() {
            return Math.max(0, Number(vm.keywordsAvailable()) - vm.keywords.length);
        }

        function refreshReviewKeywordsPage() {
            var total = (vm.keywords || []).length;
            vm.reviewKeywordsPages = Math.max(1, Math.ceil(total / reviewKeywordsPageSize));
            vm.reviewKeywordsPage = Math.max(0, Math.min(
                vm.reviewKeywordsPages - 1,
                Number(vm.reviewKeywordsPage) || 0
            ));
            var start = vm.reviewKeywordsPage * reviewKeywordsPageSize;
            vm.reviewKeywordsPageRows = (vm.keywords || []).slice(
                start,
                start + reviewKeywordsPageSize
            );
        }

        function changeReviewKeywordsPage(direction) {
            vm.reviewKeywordsPage = Math.max(0, Math.min(
                vm.reviewKeywordsPages - 1,
                vm.reviewKeywordsPage + direction
            ));
            refreshReviewKeywordsPage();
        }

        function keywordVolume(keyword) {
            var metrics = vm.keywordDiscoveryState && vm.keywordDiscoveryState.metrics;
            var metric = metrics && metrics[keyword];
            return metric && metric.monthlySearches !== null &&
                metric.monthlySearches !== undefined ? metric.monthlySearches : null;
        }

        function removeKeyword(keyword) {
            var index = vm.keywords.indexOf(keyword);
            if (index !== -1) {
                vm.keywords.splice(index, 1);
            }
        }

        function clearAllKeywords() {
            vm.keywords.length = 0;
        }

        function manualKeywordsToAdd() {
            if (!vm.reviewManual.draft || !vm.reviewManual.draft.trim()) {
                return [];
            }
            var existing = Object.create(null);
            vm.keywords.forEach(function (keyword) {
                existing[String(keyword).toLowerCase()] = true;
            });
            return vm.reviewManual.draft.trim().split(/[,\n\r]+/).reduce(function (result, raw) {
                var keyword = String(raw || '').trim().replace(/\s+/g, ' ');
                var key = keyword.toLowerCase();
                if (keyword.length > 1 && !existing[key]) {
                    existing[key] = true;
                    result.push(keyword);
                }
                return result;
            }, []);
        }

        function addManualKeywords() {
            if (!vm.limits.ready) {
                showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                return;
            }
            var capacity = Math.max(0, vm.keywordsAvailable() - vm.keywords.length);
            var pending = manualKeywordsToAdd();
            if (!pending.length) {
                return;
            }
            if (!capacity) {
                showCustomToast('project.wizard.limits.notEnoughKeywords', 'icon-x st-red');
                return;
            }
            pending.slice(0, capacity).forEach(function (keyword) {
                vm.keywords.push(keyword);
            });
            vm.reviewManual.draft = '';
            if (pending.length > capacity) {
                showCustomToast('project.wizard.keywords.capacityLimited', 'icon-x st-red');
            }
        }

        function skipKeywordMonitoring() {
            if (vm.loading.post || vm.loading.creatingProject) {
                return;
            }
            createAProject({
                skipKeywordMonitoring: true
            });
        }

        var stoTool = 'SEO Project';

        function getSuggestedCompetitors(url, keyword) {
            ProjectsService.suggestedCompetitors(url, keyword)
                .then(function (res) {
                    $scope.suggestedCompetitors = [];
                    if (res && res.data && res.data.competitors) {
                        angular.forEach(res.data.competitors, function (suggestedCompetitor) {
                            $scope.suggestedCompetitors.push({
                                url: suggestedCompetitor,
                                domainType: 'domain_with_subdomains',
                            })
                        });
                    }
                })
                .catch(function (err) {
                    console.log(err);
                })
        }

        function applyKeywordLimits(limits) {
            var applied = false;
            angular.forEach(limits, function (service) {
                if (service.alias === 'rank-tracker-keywords' &&
                    service.qtyAllowed !== undefined && service.qtyAllowed !== null) {
                    $scope.keywordsLimit = Number(service.qtyAllowed) || 0;
                    applied = true;
                }
            });
            return applied;
        }

        function applySessionKeywordLimits() {
            return UserService.sessionInfo().then(function (session) {
                if (!session || !session.data || !session.data.limits ||
                    !applyKeywordLimits(session.data.limits)) {
                    throw new Error('Keyword plan limit unavailable');
                }
                return true;
            });
        }

        function requestKeywordLimits() {
            return UserService.limits()
                .then(function (res) {
                    if (res && res.data && res.data.limits &&
                        applyKeywordLimits(res.data.limits)) {
                        return true;
                    }
                    return applySessionKeywordLimits();
                })
                .catch(function (err) {
                    console.log(err);
                    return applySessionKeywordLimits();
                });
        }

        function requestKeywordUsage() {
            return KeywordTrackerService.keywordCountTracker()
                .then(function (res) {
                    if (!res || !res.data || res.data.keywords === undefined ||
                        res.data.keywords === null) {
                        throw new Error('Keyword usage unavailable');
                    }
                    $scope.keywordsAlreadyAddedCounter = Number(res.data.keywords) || 0;
                });
        }

        function readResourceLimit(response) {
            var limits = response && response.data && response.data.limits;
            var limit = null;
            if (!Array.isArray(limits)) {
                return null;
            }
            limits.forEach(function (service) {
                if (service.alias === 'seo-spider-limit' &&
                    service.qtyAllowed !== undefined && service.qtyAllowed !== null) {
                    var value = Number(service.qtyAllowed);
                    if (isFinite(value) && value > 0) {
                        limit = value;
                    }
                }
            });
            return limit;
        }

        function allowedResourceOptions(limit) {
            var values = allWizardResourceOptions.slice();
            if (limit > 0 && values.indexOf(limit) === -1) {
                values.push(limit);
            }
            return values.sort(function (first, second) {
                return first - second;
            }).map(function (resource) {
                return {
                    value: resource,
                    locked: resource > limit
                };
            });
        }

        function applyResourceLimit(limit) {
            var parsedLimit = Number(limit);
            if (!isFinite(parsedLimit) || parsedLimit <= 0) {
                return false;
            }

            var options = allowedResourceOptions(parsedLimit);
            if (!options.length) {
                return false;
            }

            vm.resourceLimits.max = parsedLimit;
            vm.wizardResourceOptions = options;
            vm.resourceLimits.availableOptions = options.filter(function (resource) {
                return !resource.locked;
            });
            vm.resourceLimits.lockedOptions = options.filter(function (resource) {
                return resource.locked;
            });

            var requested = Number(vm.schedule.resourcesLimit);
            var selected = options[0].value;
            options.forEach(function (resource) {
                if (!resource.locked && resource.value <= requested) {
                    selected = resource.value;
                }
            });
            vm.schedule.resourcesLimit = selected;
            vm.lastAllowedResourcesLimit = selected;

            vm.resourceLimits.ready = true;
            vm.resourceLimits.error = false;
            return true;
        }

        function requestResourceLimit() {
            if (vm.resourceLimits.loading || vm.resourceLimits.ready) {
                return $q.when(vm.resourceLimits.ready);
            }

            vm.resourceLimits.loading = true;
            vm.resourceLimits.error = false;
            var applyResponse = function (response) {
                var limit = readResourceLimit(response);
                if (limit === null || !applyResourceLimit(limit)) {
                    throw new Error('Spider resource limit unavailable');
                }
                return true;
            };

            return UserService.limits()
                .then(applyResponse)
                .catch(function () {
                    return UserService.sessionInfo().then(applyResponse);
                })
                .catch(function (error) {
                    vm.resourceLimits.ready = false;
                    vm.resourceLimits.error = true;
                    console.log(error);
                    return false;
                })
                .finally(function () {
                    vm.resourceLimits.loading = false;
                });
        }

        function onResourcesLimitChange(resourcesLimit) {
            var requestedLimit = Number(resourcesLimit);
            var selectedResource = vm.wizardResourceOptions.filter(function (resource) {
                return resource.value === requestedLimit;
            })[0];

            if (!selectedResource || !selectedResource.locked) {
                if (selectedResource) {
                    vm.lastAllowedResourcesLimit = requestedLimit;
                }
                return;
            }

            vm.schedule.resourcesLimit = vm.lastAllowedResourcesLimit || vm.resourceLimits.max;
            vm.resourceLimits.pickerOpen = false;
            $state.go('upgrade.choose-plan', {type: 'agency'});
        }

        function toggleResourcePicker() {
            if (!vm.resourceLimits.ready) {
                return;
            }
            vm.resourceLimits.pickerOpen = !vm.resourceLimits.pickerOpen;
        }

        function closeResourcePicker() {
            vm.resourceLimits.pickerOpen = false;
        }

        function selectWizardResource(resource) {
            if (!resource) {
                return;
            }
            if (resource.locked) {
                onResourcesLimitChange(resource.value);
                return;
            }
            vm.schedule.resourcesLimit = resource.value;
            vm.lastAllowedResourcesLimit = resource.value;
            closeResourcePicker();
        }

        function onResourcePickerKeydown(event) {
            if (event && event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                closeResourcePicker();
            }
        }

        function isResourceLimitAllowed() {
            var requested = Number(vm.schedule.resourcesLimit);
            var limit = Number(vm.resourceLimits.max);
            return vm.resourceLimits.ready &&
                isFinite(requested) && isFinite(limit) &&
                requested > 0 && requested <= limit;
        }

        vm.onResourcesLimitChange = onResourcesLimitChange;
        vm.toggleResourcePicker = toggleResourcePicker;
        vm.closeResourcePicker = closeResourcePicker;
        vm.selectWizardResource = selectWizardResource;
        vm.onResourcePickerKeydown = onResourcePickerKeydown;

        function getLimits() {
            if (vm.limits.loading) {
                return;
            }
            vm.limits.loading = true;
            vm.limits.loaded = false;
            vm.limits.ready = false;
            vm.limits.error = false;
            $q.all([requestKeywordLimits(), requestKeywordUsage()])
                .then(function () {
                    vm.limits.loaded = true;
                    vm.limits.ready = true;
                    $scope.keywordsExceeded();
                })
                .catch(function (err) {
                    vm.limits.loaded = true;
                    vm.limits.ready = false;
                    vm.limits.error = true;
                    $scope.loading.exceeded = true;
                    console.log(err);
                })
                .finally(function () {
                    vm.limits.loading = false;
                });
        }

        vm.goToPreviousStep = function () {
            if (vm.loading.post) {
                return;
            }
            if (vm.step === 1) {
                $state.go($stateParams.from === 'seo-spider' ? 'app.seospider.list' : 'app.welcome');
                return;
            }
            if (vm.step === 3) {
                vm.step = vm.sourceMode === 'search-console' ? 1 : 2;
            } else {
                vm.step -= 1;
            }
            updateUrlParams(vm.step);
        };

        vm.goToNextStep = function () {
            if (vm.loading.post) {
                return;
            }
            // $debounce is used to avoid multiple rapid clicks
            $debounce(goToNextStepAction, 400);
        };

        function goToNextStepAction() {
            if (vm.step === 1) {
                if (!vm.sourceMode) {
                    showCustomToast('project.wizard.newFlow.selectSource', 'icon-x st-red');
                    return;
                }
                if (vm.sourceMode === 'search-console' && (!vm.gsc.draftId || !vm.gsc.selectedProperty)) {
                    showCustomToast('project.wizard.newFlow.connectGscFirst', 'icon-x st-red');
                    return;
                }
                if (!isValidUrl(vm.project.url) || !isValidProjectName(vm.project.name)) {
                    if (vm.projectForm) {
                        if (!isValidUrl(vm.project.url)) {
                            vm.projectForm.url.$setValidity('pattern', false);
                        }
                        if (!isValidProjectName(vm.project.name)) {
                            vm.projectForm.name.$setValidity('pattern', false);
                        }
                    }
                    if (!isValidProjectName(vm.project.name)) {
                        showCustomToast('project.wizard.name.is.invalid', 'icon-x st-red');
                    }
                    return;
                }
                if (!AuthService.isAuthenticated()) {
                    stAlertLimitService.open('auth-login', {
                        error: {
                            request: {
                                alias: 'seo-project',
                                offline: false,
                            }
                        },
                        canClose: false,
                    });
                    return;
                }
                persistDraftProjectAndContinue();
                return;
            }

            if (vm.step === 2) {
                vm.step = 3;
                updateUrlParams(vm.step);
                return;
            }

            if (vm.step === 3) {
                if (!isResourceLimitAllowed()) {
                    requestResourceLimit();
                    showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                    return;
                }
                vm.step = 4;
                updateUrlParams(vm.step);
                return;
            }

            if (vm.step === 4) {
                vm.step = 5;
                updateUrlParams(vm.step);
                prepareKeywordsStep();
                if (!vm.limits.ready) {
                    getLimits();
                }
                return;
            }

            if (vm.step === 5 && vm.keywords.length === 0) {
                showCustomToast('project.wizard.add.one.keyword', 'icon-x st-red');
                return;
            }

            if (vm.step === 5) {
                if (!vm.limits.ready) {
                    showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                    return;
                }
                if (vm.keywords.length > vm.keywordsAvailable()) {
                    showCustomToast('project.wizard.limits.notEnoughKeywords', 'icon-x st-red');
                    return;
                }
                vm.step = 6;
                updateUrlParams(vm.step);
                return;
            }

            if (vm.step === 6 && !vm.locations.length) {
                showCustomToast('project.wizard.locations.atLeastOne', 'icon-x st-red');
                return;
            }

            if (vm.step === 6) {
                if (!vm.limits.ready) {
                    showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                    return;
                }
                if ((vm.keywords.length * vm.locations.length) > vm.keywordsAvailable()) {
                    showCustomToast('project.wizard.limits.notEnoughLocations', 'icon-x st-red');
                    return;
                }
                createAProject();
            }
        }

        function setStepsWizard() {
            var stepsDefault = [{
                    stepNumber: 1,
                    stepLabel: 'project.wizard.step.site'
                },
                {
                    stepNumber: 2,
                    stepLabel: 'project.wizard.step.searchConsole',
                    optional: true
                },
                {
                    stepNumber: 3,
                    stepLabel: 'project.wizard.step.crawl'
                },
                {
                    stepNumber: 4,
                    stepLabel: 'project.wizard.step.scan'
                },
            ];

            stepsDefault.push({
                stepNumber: 5,
                stepLabel: 'project.wizard.step.keywords'
            });
            stepsDefault.push({
                stepNumber: 6,
                stepLabel: 'project.wizard.step.locations'
            });
            return stepsDefault;
        }

        function persistDraftProjectAndContinue() {
            vm.loading.post = true;
            ProjectsService.getByName(vm.project.name)
                .then(function (res) {
                    if (existingProjectFromResponse(res)) {
                        reportDuplicateProjectName(false);
                        return;
                    }
                    localStorage.setItem('projectName', vm.project.name);
                    localStorage.setItem('project', JSON.stringify(vm.project));
                    suggestDefaultLocationCountry();
                    saveWizardDraft();
                    getLimits();
                    vm.step = vm.sourceMode === 'search-console' ? 3 : 2;
                    updateUrlParams(vm.step);
                })
                .catch(function (err) {
                    console.log(err);
                    showCustomToast('project.wizard.something.went.wrong', 'icon-x st-red');
                })
                .finally(function () {
                    vm.loading.post = false;
                });
        }

        function prepareKeywordsStep() {
            vm.keywordsExceeded();
            if (vm.keywords && vm.keywords.length > 0) {
                getSuggestedCompetitors(vm.project.url, vm.keywords[vm.keywords.length - 1]);
            }
        }

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template: '<md-toast layout="row" flex class="md-toast">' +
                    '   <div><i class="' + classIcon + ' m-r-sm"></i></div>' +
                    '   <div>' + $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right',
                parent: $element[0].querySelector('.toast-show')
            });
        }

        function projectErrorCode(error) {
            return error && error.data && error.data.error && error.data.error.code || '';
        }

        function projectErrorMessage(error) {
            return String(
                error && error.data && error.data.error && error.data.error.message ||
                error && error.error && error.error.message ||
                error && error.message ||
                ''
            );
        }

        function isDuplicateProjectError(error) {
            return /(project name duplicated|nome.*duplicat|nome.*esiste)/i.test(projectErrorMessage(error));
        }

        function resetCreationLoading() {
            $scope.loading.post = false;
            vm.loading.creatingProject = false;
        }

        function recoverProjectAfterDuplicate(project) {
            return ProjectsService.getByName(project.name)
                .then(function (res) {
                    var existing = existingProjectFromResponse(res);
                    if (existing && isSameWizardProject(existing) && existing.id) {
                        resumeExistingProject(existing);
                        return;
                    }
                    reportDuplicateProjectName(true);
                    resetCreationLoading();
                })
                .catch(function (error) {
                    reportDuplicateProjectName(true);
                    resetCreationLoading();
                    console.log(error);
                });
        }

        function createAProject(options) {
            var skipKeywordMonitoring = !!(options && options.skipKeywordMonitoring);
            var pendingCreatedProject = readCreatedProject();
            if (pendingCreatedProject) {
                vm.loading.post = true;
                vm.loading.creatingProject = true;
                goToProject(pendingCreatedProject);
                return;
            }
            if (vm.loading.post || vm.loading.creatingProject) {
                return;
            }
            if (!isValidUrl(vm.project.url)) {
                showCustomToast('project.wizard.invalid.url', 'icon-x st-red');
                return;
            }
            if (!isValidProjectName(vm.project.name)) {
                showCustomToast('project.wizard.name.is.invalid', 'icon-x st-red');
                return;
            }
            if (!isResourceLimitAllowed()) {
                requestResourceLimit();
                showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                return;
            }
            if (!skipKeywordMonitoring && !vm.limits.ready) {
                showCustomToast('project.wizard.limits.unavailable', 'icon-x st-red');
                return;
            }
            if (!skipKeywordMonitoring && !vm.locations.length) {
                showCustomToast('project.wizard.locations.atLeastOne', 'icon-x st-red');
                return;
            }
            if (!skipKeywordMonitoring &&
                (vm.keywords.length * vm.locations.length) > vm.keywordsAvailable()) {
                showCustomToast('project.wizard.limits.notEnoughLocations', 'icon-x st-red');
                return;
            }
            vm.loading.creatingProject = true;
            $scope.loading.post = true;
            var project = {
                name: $scope.project.name,
                protocol: $scope.project.protocol,
                url: $scope.project.url,
                domainType: $scope.project.domainType,
                crawlerNow: $scope.schedule.crawlerNow,
                crawler: {
                    respectRobots: $scope.schedule.respectRobots,
                    maxDepth: $scope.schedule.maxDepth,
                    resourcesLimit: $scope.schedule.resourcesLimit,
                    userAgent: $scope.schedule.userAgent,
                    speed: $scope.schedule.speed,
                    scheduleFrequency: $scope.schedule.scheduleFrequency,
                    scheduleStartDay: $scope.schedule.scheduleStartDay,
                    scheduleStartHour: $scope.schedule.scheduleStartHour,
                    scheduleTimezoneOffset: $scope.schedule.scheduleTimezoneOffset,
                    runScheduled: $scope.schedule.runScheduled ? 1 : 0,
                },
                keywords: skipKeywordMonitoring ? [] : $scope.keywords,
                locations: skipKeywordMonitoring ? [] : $scope.locations,
                competitors: $scope.competitors
            };

            /* Re-check immediately before the POST. This catches stale drafts
               and a project created by another tab/navigation while the wizard
               was open. */
            ProjectsService.getByName(project.name)
                .then(function (res) {
                    var existing = existingProjectFromResponse(res);
                    if (existing) {
                        if (isSameWizardProject(existing) && existing.id) {
                            resumeExistingProject(existing);
                        } else {
                            reportDuplicateProjectName(true);
                            resetCreationLoading();
                        }
                        return;
                    }

                    return ProjectsService.createProject(project)
                        .then(function (createResponse) {
                            var projectData = createResponse && createResponse.data;
                            if (!projectData || !projectData.projectId) {
                                throw new Error('Project creation response did not include projectId');
                            }
                            rememberCreatedProject(projectData.projectId);
                            clearWizardDraft();
                            var connection = $q.when();
                            if (vm.gsc.draftId && vm.gsc.selectedProperty) {
                                connection = SearchConsoleService.connectDraftToProject(
                                    vm.gsc.draftId,
                                    projectData.projectId,
                                    vm.gsc.selectedProperty.siteUrl,
                                ).catch(function (error) {
                                    console.log(error);
                                });
                            }
                            return connection.then(function () {
                                return finishProjectCreation(projectData);
                            });
                        })
                        .catch(function (error) {
                            if (projectErrorCode(error) === 'INTERNAL_SERVER_ERROR' &&
                                isDuplicateProjectError(error)) {
                                return recoverProjectAfterDuplicate(project);
                            }
                            showCustomToast('project.wizard.project.not.saved', 'icon-x st-red');
                            resetCreationLoading();
                            console.log(error);
                        });
                })
                .catch(function (error) {
                    showCustomToast('project.wizard.project.not.saved', 'icon-x st-red');
                    resetCreationLoading();
                    console.log(error);
                });
        }

        function finishProjectCreation(data) {
            var toastMessage = $scope.isFirstProject ? 'project.wizard.first.project.saved' : 'project.wizard.project.saved';
            showCustomToast(toastMessage, 'icon-checkmark st-green');
            clearWizardDraft();
            var eventLabel = $rootScope.stoFrom ? stoTool + ' - ' + $rootScope.stoFrom : stoTool;
            TrackEventService.event(
                'Suite Usages',
                'SEO Project - Created', eventLabel);
            TrackEventService.gaV2Event(
                'project_create', {
                    from: $rootScope.stoFrom,
                    type: stoTool
                });

            CRMService.addEvents(['ProjectCreatedEvent'], [
                'ProjectToConfigEvent',
                'ProjectToCreateEvent',
            ]);

            if ($scope.schedule.crawlerNow) {
                TrackEventService.event(
                    'Suite Usages',
                    'SEO Project - Start Crawl', eventLabel);
                TrackEventService.gaV2Event(
                    'crawl_start', {
                        from: $rootScope.stoFrom
                    });
            }
            return goToProject(data);
        }

        function goToProject(data) {
            if (!data || !data.projectId) {
                showCustomToast('project.wizard.newFlow.overviewRedirectError', 'icon-x st-red');
                vm.loading.post = false;
                vm.loading.creatingProject = false;
                return;
            }
            if (data.trackerProjectId) {
                localStorage.removeItem('project-filters' + data.trackerProjectId);
            }

            /* The overview owns the post-creation state: live crawl when the
               user opted in, otherwise the first-scan call to action. */
            var transition = $state.go('app.project.detail.overview', {
                projectId: data.projectId
            });
            return $q.when(transition).then(function () {
                clearCreatedProjectMarker();
            }).catch(function (err) {
                showCustomToast('project.wizard.newFlow.overviewRedirectError', 'icon-x st-red');
                vm.loading.post = false;
                vm.loading.creatingProject = false;
                console.log(err);
            });
        }

        function getNameProject(projectName) {
            $scope.loading.post = true;
            ProjectsService.getByName(projectName)
                .then(function (res) {
                    if (res && res.data && res.data.project) {
                        showCustomToast('project.wizard.this.name.already.exists', 'icon-x st-red');
                        $scope.loading.post = false;
                        $element[0].querySelector('#name-input').focus();
                        return;
                    }

                    $scope.loading.post = false;
                    $scope.step = $scope.step + 1;
                    updateUrlParams($scope.step);
                })
                .catch(function (err) {
                    $scope.loading.post = false;
                    $element[0].querySelector('#name-input').focus();
                    console.log(err);
                });
        }

        function updateUrlParams(step) {
            var params = {
                step: getKeyByValue(stepKeys, step),
                from: $stateParams.from,
                url: $stateParams.url
            };
            $state.transitionTo('app.project.wizard', params, {
                notify: false
            });
            $stateParams = params;
        }

        function getKeyByValue(object, value) {
            return Object.keys(object).filter(function (key) {
                return object[key] === value;
            })[0];
        }

        function isValidUrl(urlString) {
            var regex = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, "i");
            return regex.test(urlString);
        }

        function isValidProjectName(projectName) {
            return typeof projectName === 'string' &&
                projectName.length <= 128 &&
                /^[a-zA-Z0-9\_\- ]*$/.test(projectName) &&
                projectName.trim().length > 0;
        }

        $scope.isLimitExceeded = function () {
            return ($scope.keywordsCount * $scope.locationsCount) + $scope.keywordsAlreadyAddedCounter > $scope.keywordsLimit;
        };

        $scope.keywordsExceeded = function () {
            $scope.keywordsCount = $scope.keywords.length;
            $scope.loading.exceeded = $scope.isLimitExceeded();
            refreshReviewKeywordsPage();
        };

        $scope.locationsExceeded = function () {
            $scope.locationsCount = ($scope.locations && $scope.locations.length) || 1;
            $scope.loading.exceeded = $scope.isLimitExceeded();
        }

        draftReady = true;
        requestResourceLimit();
        if (vm.step >= 5) {
            getLimits();
        }
        refreshReviewKeywordsPage();
        saveWizardDraft();
        $scope.$watch('step', saveWizardDraft);
        $scope.$watch('sourceMode', saveWizardDraft);
        $scope.$watch('project', saveWizardDraft, true);
        $scope.$watch('schedule', saveWizardDraft, true);
        $scope.$watch('gsc.draftId', saveWizardDraft);
        $scope.$watch('gsc.selectedProperty', saveWizardDraft, true);
        $scope.$watchCollection('gsc.properties', saveWizardDraft);
        $scope.$watchCollection('locations', function () {
            $scope.locationsExceeded();
            saveWizardDraft();
        });

        $scope.$watchCollection('keywords', function () {
            if ($scope.step === 5 || $scope.step === 6) {
                $scope.keywordsExceeded();
            }
            saveWizardDraft();
        });
        $scope.$watchGroup(['keywordsAlreadyAddedCounter', 'keywordsLimit'], function () {
            if ($scope.step === 5) {
                $scope.keywordsExceeded();
            }
        });

        $scope.$on('$destroy', function () {
            saveWizardDraft();
            stopGscPolling();
        });
    }

    Controller.$inject = [
        'AuthService',
        '$scope',
        '$stateParams',
        '$state',
        '$mdToast',
        '$translate',
        'ProjectsService',
        '$element',
        'LanguageService',
        'CountriesService',
        'TimezoneService',
        'FavIconService',
        '$debounce',
        'stAlertLimitService',
        'UserService',
        'KeywordTrackerService',
        'TrackEventService',
        '$rootScope',
        'CRMService',
        'SearchConsoleService',
        '$window',
        '$interval',
        '$q',
    ];
    return Controller;
});
